import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  const userToken = window.sessionStorage.getItem("adminToken");
  if (userToken) {
    return <Outlet />;
  } else {
    return <Navigate to={"/"} />;
  }
};

export default ProtectedRoutes;
